// extracted by mini-css-extract-plugin
export default {"root":"IconLandscapes_root__SKXnW"};